
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Play } from "lucide-react";

interface ModuleType {
  id: string;
  title: string;
  lessons: {
    id: string;
    title: string;
    duration: string;
  }[];
}

interface CourseContentProps {
  modulesList: ModuleType[];
  isLoading: boolean;
  error: unknown;
}

const CourseContent = ({ modulesList, isLoading, error }: CourseContentProps) => {
  if (isLoading) {
    return (
      <div className="animate-pulse space-y-4">
        {[...Array(3)].map((_, i) => (
          <div key={i} className="h-16 bg-gray-200 rounded"></div>
        ))}
      </div>
    );
  }

  if (error) {
    return <p className="text-red-500">Kursuse sisu laadimine ebaõnnestus. Palun proovi hiljem uuesti.</p>;
  }

  if (modulesList.length === 0) {
    return <p className="text-yellow-600">Kursuse sisu pole veel saadaval.</p>;
  }

  return (
    <Accordion type="single" collapsible className="w-full">
      {modulesList.map((module) => (
        <AccordionItem key={module.id} value={module.id}>
          <AccordionTrigger className="text-lg font-medium">
            {module.title}
          </AccordionTrigger>
          <AccordionContent>
            <ul className="space-y-3 py-2">
              {module.lessons.map((lesson) => (
                <li key={lesson.id} className="flex items-center justify-between p-2 hover:bg-gray-50 rounded-md">
                  <div className="flex items-center">
                    <Play className="h-4 w-4 mr-2 text-kaija-accent" />
                    <span>{lesson.title}</span>
                  </div>
                  <span className="text-sm text-gray-500">{lesson.duration}</span>
                </li>
              ))}
            </ul>
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
};

export default CourseContent;
